<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="row">
      <div id="page-header" class="col-lg-9 col-12">
        <div class="content-header row" *ngIf="contentHeader">
          <div class="content-header-left col-12 mb-2">
            <div class="row breadcrumbs-top">
              <div class="col-12">
                <h2 class="content-header-title mb-0">
                  {{ contentHeader.headerTitle | translate }}
                  <span class="ml-1 font-medium-1"
                  >({{ "WORKING_HOURS" | translate }} {{ _utilService.formatDate(this.selectedYear + "-" + this.selectedMonth.padStart(2, "0") + "-01", "MMMM") | titlecase }} {{ totalWorkedHourMonthSelected }}h)
                  </span>
                </h2>
                <app-breadcrumb *ngIf="contentHeader.breadcrumb.links.length > 0" [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-title px-2 pt-2 mb-0">
        <div [ngClass.xl]="'float-left row pl-1'">
          <input
            type="search"
            id="datatable-search-input"
            [placeholder]="'SEARCH' | translate"
            class="form-control"
            [ngClass.xl]="'w-fit d-inline-block'"
            [ngClass.sm]="'mb-075'"
            [ngClass.md]="'mb-075'"
            [(ngModel)]="searchKeyword"
            (ngModelChange)="reportsFilterList(false); changeQueryParams()"
          />
          <select [(ngModel)]="searchStatus" (ngModelChange)="reportsFilterList(false); changeQueryParams()" class="form-control" [ngClass.xl]="'w-fit d-inline-block ml-1'">
            <option value="10" selected>{{ "ALL_STATE" | translate }}</option>
            <option value="0">{{ "SAVED_PLURAL" | translate }}</option>
            <option value="1">{{ "PENDING" | translate }}</option>
            <option value="2">{{ "APPROVED_PLURAL_MALE" | translate }}</option>
            <option value="3">{{ "NOT_APPROVED_PLURAL_MALE" | translate }}</option>
            <option value="4">{{ "NOT_SENDED_PLURAL" | translate }}</option>
          </select>
          <select [(ngModel)]="searchTypeUser" (ngModelChange)="reportsFilterList(false); changeQueryParams()" class="form-control" [ngClass.xl]="'w-fit d-inline-block ml-1'" [ngClass.md]="'mt-075'">
            <option value="all" selected>{{ "USER_TYPE" | translate }}</option>
            <option value="Dipendente">{{ "EMPLOYEE" | translate }}</option>
            <option value="Collaboratore">{{ "COLLABORATOR" | translate }}</option>
          </select>
        </div>
        <div class="float-right ml-1" [ngClass.xl]="'d-flex'" [ngClass.sm]="'d-none'" [ngClass.md]="'d-flex mt-075'">
          <div class="w-fit">
            <label class="d-flex align-items-center">{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <div class="ml-1" *ngIf="_authenticationService.hasCapability('view_excel_report')">
            <a class="text-primary btn btn-outline-primary" (click)="exportReportExcel()">
              {{ "EXPORT_EXCEL" | translate }}
            </a>
          </div>
        </div>

        <div [ngClass.xl]="'float-right'" [ngClass.sm]="'mt-075'" [ngClass.md]="'mt-075'">
          <div class="d-flex">
            <label for="monthYear" class="mb-0" [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
              <select [(ngModel)]="selectedMonth" (ngModelChange)="reportsFilterList(); changeQueryParams()" id="monthYear" class="form-control pr-3 text-capitalize">
                <option selected disabled value="all">{{ "MONTH" | translate }}</option>
                <option *ngFor="let month of availableMonths" [value]="month" [label]="formatLabel(month)">{{ month }}</option>
              </select>
            </label>
            <label for="years" class="mb-0 ml-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
              <select id="years" [(ngModel)]="selectedYear" (change)="reportsFilterList(); changeQueryParams()" class="form-control pr-3">
                <option selected disabled value="all">{{ "YEAR" | translate }}</option>
                <option *ngFor="let year of availableYears">{{ year }}</option>
              </select>
            </label>
          </div>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 60 : 190"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="reports"
          [offset]="pageNumber"
          (page)="setPage($event)"
        >
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="complete_name" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="'/dashboard/user/profile/' + row.hash" target="_blank" class="d-flex align-items-center">
                <div class="avatar bg-primary mr-1" *ngIf="row.imageError">
                  <div class="avatar-content">{{ row.complete_name ? row.complete_name[0] : "-" }}</div>
                </div>
                <img *ngIf="!row.imageError" class="avatar mr-1 contain" (error)="row.imageError = true" [src]="row.avatar" alt="Avatar" height="30" width="30" />
                <span>{{ row.complete_name }}</span>
              </a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'MONTH' | translate }}" width="70" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ formatLabel(selectedMonth) }} {{ selectedYear }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="status" width="90" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <ng-container *ngIf="row.currentReport && row.currentReport.length > 0 && row.currentReport[0]">
                <span class="badge" [ngClass]="{
                  'badge-info': row.currentReport[0].status === 0,
                  'badge-warning': row.currentReport[0].status === 1,
                  'badge-success': row.currentReport[0].status === 2,
                  'badge-danger': row.currentReport[0].status === 3,
                  'badge-secondary': row.currentReport[0].status === 4
                }">{{ row.currentReport[0].status === 4 ? ("NOT_SENDED" | translate) : row.currentReport[0].enabled_label }}</span>
              </ng-container>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'WORKED_HOURS' | translate }}" width="90" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.currentReport[0].worked_hours || 0 }}h</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'EXTRA_HOURS' | translate }}" width="70" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.currentReport[0].extra_hours || 0 }}h</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" [width]="200" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center mr-1" style="gap: 0.5rem" *ngIf="row.currentReport && row.currentReport.length > 0 && row.currentReport[0].status !== 4 && row.currentReport[0].user_hash !== me.hash">
                  <a class="btn btn-sm" [routerLink]="'/dashboard/workday-report/single/' + row.currentReport[0].id" [ngbTooltip]="'VIEW' | translate">
                    <i class="text-info" [data-feather]="'eye'" size="19"></i>
                  </a>
                  <button has_capability="view_pdf_report" *ngIf="row.currentReport[0].status === 2" class="btn btn-sm" (click)="exportReportPDF(row.currentReport[0].id)" [ngbTooltip]="'GENERATE_PDF' | translate">
                    <i [data-feather]="'download'" size="19"></i>
                  </button>
                  <button has_capability="edit_workday_report_status" class="btn btn-sm" (click)="approveReport(row)" *ngIf="canApprove(row)" [ngbTooltip]="'APPROVE' | translate ">
                    <i class="text-success" [data-feather]="'check-square'" size="19"></i>
                  </button>
                  <button has_capability="update_workday_report_approvement" class="btn btn-sm" (click)="approveReport(row)" [ngbTooltip]="'UPDATE_APPROVEMENT' | translate">
                    <i class="text-warning" [data-feather]="'refresh-cw'" size="19"></i>
                  </button>
                  <button has_capability="edit_workday_report_status" class="btn btn-sm remove-item" (click)="unlock(row, noteUnlockModal)" *ngIf="canUnlock(row)" [ngbTooltip]="'UNLOCK_WORKDAY_REPORT' | translate">
                    <i class="text-danger" [data-feather]="'unlock'" size="19"></i>
                  </button>
                </div>
                <button has_capability="generate_others_workday_report" class="btn border-0 btn-sm " (click)="generateReport(row)" *ngIf="canGenerate(row)" [ngbTooltip]="'GENERATE' | translate">
                  <i class="text-primary" [data-feather]="'tool'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="complete_name" width="150" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <a [routerLink]="'/dashboard/user/profile/' + row.hash" class="col-12">
                  <span>
                    <div class="avatar bg-primary" *ngIf="row.imageError">
                      <div class="avatar-content">{{ row.complete_name ? row.complete_name[0] : "-" }}</div>
                    </div>
                    <img *ngIf="!row.imageError" (error)="row.imageError = true" class="avatar" [src]="'https://cdn.nepta.dev/avatar/' + row.hash + '.png'" alt="Avatar" height="30" width="30" /> {{ row.firstname }}
                    {{ row.lastname }}</span
                  >
                </a>
                <div class="col-12 mt-1">
                  <ng-container *ngIf="row.currentReport && row.currentReport.length > 0 && row.currentReport[0]">
                    <span class="badge" [ngClass]="{
                      'badge-info': row.currentReport[0].status === 0,
                      'badge-warning': row.currentReport[0].status === 1,
                      'badge-success': row.currentReport[0].status === 2,
                      'badge-danger': row.currentReport[0].status === 3,
                      'badge-secondary': row.currentReport[0].status === 4
                    }">{{ row.currentReport[0].status === 4 ? ("NOT_SENDED" | translate) : row.currentReport[0].enabled_label }}</span>
                  </ng-container>
                </div>
                <div class="col-6 mt-1">{{ "WORKED_HOURS" | translate }}: {{ row.currentReport[0].worked_hours }}h</div>
                <div class="col-6 mt-1">{{ "EXTRA_HOURS" | translate }}: {{ row.currentReport[0].extra_hours }}h</div>

                <div class="col-12 my-1">
                  <div class="d-flex justify-content-end align-items-center" *ngIf="row.currentReport && row.currentReport.length > 0 && row.currentReport[0].status !== 4 && row.currentReport[0].user_hash !== me.hash">
                    <button class="btn btn-outline-secondary mr-1" [routerLink]="'/dashboard/workday-report/single/' + row.currentReport[0].id">{{ "VIEW" | translate }}</button>
                    <button has_capability="edit_workday_report_status" class="btn btn-outline-success" (click)="approveReport(row)" *ngIf="canApprove(row)">
                      {{ "APPROVE" | translate }}
                    </button>
                    <button class="bg-transparent border-0 text-secondary remove-item" (click)="unlock(row, noteUnlockModal)" has_capability="edit_workday_report_status" *ngIf="canUnlock(row)">
                      <i [data-feather]="'unlock'" size="19"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
<!-- note Unlock Modal -->
<ng-template #noteUnlockModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "INSERT_MOTIVATION_NOTE" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="rejectedNote">{{ "MOTIVATION" | translate }}<sup class="text-danger">*</sup></label>
        <textarea [(ngModel)]="unlockNote" class="form-control" name="rejectedNote" id="rejectedNote" cols="45" rows="3"></textarea>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button [disabled]="unlockNote.length < 5" (click)="sendData()" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / note Unlock Modal -->
